module.exports = __webpack_public_path__ + "static/media/QualtricsXM_Step3_Image5.0596a9dd.jpg";